import React, { useEffect } from 'react'
import { useUserColor, getUserInitials } from 'utils/users'
import * as UserPresenceStatuses from 'const/UserPresenceStatuses'
import classes from './Avatar.module.scss'

const DEFAULT_SIZE = 40

const Avatar = React.forwardRef(({
  profileKey,
  name,
  isActive = true,
  size = DEFAULT_SIZE,
  active,
  presence,
  className,
  style,

  avatar,

  fetchUserAvatar,

  ...props
}, ref) => {
  useEffect(() => {
    if (
      profileKey && (
        !avatar || (
          !avatar.isLoading && (
            !avatar.isLoaded ||
            avatar.loadedTimestamp !== avatar.avatarTimestamp
          )
        )
      )
    ) {
      fetchUserAvatar({
        profileKeys: [profileKey]
      })
    }
  }, [profileKey, avatar])

  const userColor = useUserColor(profileKey)

  let compClassName = classes.avatar
  if (isActive === false) {
    compClassName += ' ' + classes.deactivated
  } else if (avatar && avatar.src) {
    compClassName += ' ' + classes.withImage
  }
  if (active) compClassName += ' ' + classes.active
  if (className) compClassName += ' ' + className

  let avatarStyle = {
    width: size + 'px',
    height: size + 'px',
    lineHeight: size + 'px',
    fontSize: Math.ceil((size / DEFAULT_SIZE) * 18),
    ...style
  }

  if (isActive && avatar && avatar.src) {
    avatarStyle = {
      ...avatarStyle,
      backgroundImage: 'url(' + avatar.src + ')'
    }
  } else {
    avatarStyle = {
      ...avatarStyle,
      backgroundColor: userColor,
    }
  }

  const showInitials = !isActive || !avatar || !avatar.src

  let presenceIndicatorClassName = classes.presenceIndicator
  if (presence === UserPresenceStatuses.ONLINE) {
    presenceIndicatorClassName += ` ${classes.online}`
  }

  return (
    <span
      {...props}
      ref={ref}
      className={compClassName}
      style={avatarStyle}
      title={name}
    >
      {showInitials ? (
        getUserInitials(name)
      ) : (
        <span>&nbsp;</span>
      )}
      {typeof presence !== 'undefined' &&
        <div
          className={presenceIndicatorClassName}
          style={{
            width: Math.ceil((size / DEFAULT_SIZE) * 12),
            height: Math.ceil((size / DEFAULT_SIZE) * 12),
          }}
        />
      }
    </span>
  )
})

export default Avatar
